export default {
    //频道列表
    getChannels (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/bbs/channels')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //获取频道信息
    getChannelInfo (id) {
        return new Promise((resolve, reject) => {
            axios.get('/api/bbs/' + id + '/channel')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //帖子列表
    getList (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/bbs/cards',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //帖子详情
    getShow (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/bbs/card/' + id, {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //帖子点赞
    setPraise(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/bbs/card/praise',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论点赞
    setCommentPraise(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/bbs/card-comment/praise',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //帖子评论
    getCommentList (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/bbs/card/' + id + '/comments',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //帖子评论/回复
    Comment (params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/bbs/card-comment',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //帖子收藏
    Collect(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/bbs/card/collect',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论删除
    delComment(id){
        return new Promise((resolve, reject) => {
            axios.delete('/api/bbs/card-comment/'+id+'/delete')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    delBbs(id){
        return new Promise((resolve, reject) => {
            axios.delete('/api/bbs/card/'+id+'/delete')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //获取海报
    getPoster(params){
        return new Promise((resolve, reject) => {
            axios.get('/api/bbs/share-poster',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
}